import { useQuery } from '@tanstack/react-query';
import api from '../services/authService';

export const useVendorInvoices = (page = 1, perPage = 15, filters = {}) => {
  const { data, isLoading, error } = useQuery({
    queryKey: ['vendorInvoices', page, perPage, filters],
    queryFn: async () => {
      const params = new URLSearchParams();
      params.append('page', page);
      params.append('per_page', perPage);
      
      if (filters.status) {
        params.append('status', filters.status);
      }
      if (filters.date_from) {
        params.append('date_from', filters.date_from);
      }
      if (filters.date_to) {
        params.append('date_to', filters.date_to);
      }
      if (filters.search) {
        params.append('search', filters.search);
      }
      if (filters.channel && filters.channel !== 'all') {
        params.append('channel', filters.channel);
      }
      
      const response = await api.get(`/vendor/invoices?${params.toString()}`);
      return response.data;
    }
  });

  // Handle paginated response structure
  const invoices = data?.data?.data || data?.data || [];
  const pagination = data?.data?.current_page ? {
    current_page: data.data.current_page,
    last_page: data.data.last_page,
    per_page: data.data.per_page,
    total: data.data.total,
    from: data.data.from,
    to: data.data.to
  } : null;

  // Helper function to safely format currency amounts
  const formatAmount = (amount) => {
    if (amount === null || amount === undefined || amount === '') return '0.00';
    const numAmount = typeof amount === 'string' ? parseFloat(amount) : Number(amount);
    if (isNaN(numAmount) || !isFinite(numAmount)) return '0.00';
    return numAmount.toFixed(2);
  };

  // Format date to be more readable
  const formatDate = (dateString) => {
    if (!dateString) return 'N/A';
    const date = new Date(dateString);
    return date.toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    });
  };

  // Format time
  const formatTime = (dateString) => {
    if (!dateString) return 'N/A';
    const date = new Date(dateString);
    return date.toLocaleTimeString('en-US', {
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  const getStatusColor = (status) => {
    switch (status) {
      case 'paid':
        return 'bg-green-100 text-green-800';
      case 'sent':
      case 'pending':
        return 'bg-yellow-100 text-yellow-800';
      case 'overdue':
        return 'bg-red-100 text-red-800';
      case 'draft':
        return 'bg-gray-100 text-gray-800';
      case 'cancelled':
        return 'bg-gray-100 text-gray-800';
      default:
        return 'bg-gray-100 text-gray-800';
    }
  };

  return {
    invoices,
    isLoading,
    error,
    pagination,
    formatAmount,
    formatDate,
    formatTime,
    getStatusColor
  };
};

